import React from 'react';

const CookieConsent = ({ onAccept }) => {
  const bannerStyle = {
    position: 'fixed',
    bottom: '0',
    left: '0',
    width: '100%',
    backgroundColor: '#212121', // Un fondo oscuro para que resalte
    color: 'white',
    padding: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
    zIndex: 1000,
    gap: '16px',
    flexWrap: 'wrap',
    textAlign: 'center',
  };

  const buttonStyle = {
    backgroundColor: '#3b82f6', // Botón azul
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontWeight: 'bold',
  };

  return (
    <div style={bannerStyle}>
      <span>Esta página utiliza cookies para mejorar la experiencia de usuario.</span>
      <button style={buttonStyle} onClick={onAccept}>Aceptar</button>
    </div>
  );
};

export default CookieConsent;